import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enLocales from '../locales/en.json';
import deLocales from '../locales/de.json';
import esLocales from '../locales/es.json';
import zhLocales from '../locales/zh.json';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: { translation: enLocales },
      de: { translation: deLocales },
      es: { translation: esLocales },
      zh: { translation: zhLocales },
    }
  });

export default i18n;
